import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from "@angular/forms";
import { TechnologiesComponent } from "../../shared/technologies/technologies.component";
import { SectionBannerComponent } from "../../shared/section-banner/section-banner.component";
import { CommonModule } from "@angular/common";
import { firstValueFrom } from "rxjs";
import { ImageConverterPipe } from "../../pipes/image-converter.pipe";
import { EmailService } from "../../services/email/email.service";
import { NewsletterComponent } from "../newsletter/newsletter.component";
import { MapsLoaderService } from "../../shared/maps-loader/maps-loader.service";
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [
    SectionBannerComponent,
    TechnologiesComponent,
    ReactiveFormsModule,
    CommonModule,
    ImageConverterPipe,
    NewsletterComponent,
    TranslateModule
  ],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  form!: FormGroup;
  formSubmitted: boolean = false;
  mapReady = false;
  map!: google.maps.Map;

  @ViewChild('mapContainer', { static: false }) mapElementRef!: ElementRef;

  constructor(
    private fb: FormBuilder,
    private _sendEmail: EmailService,
    private mapsLoader: MapsLoaderService,
    private translate: TranslateService,
  ) {}

  async ngOnInit() {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(/^[\p{L}\s]+$/u)]],
      email: ['', [Validators.required, Validators.email]],
      message: ['', [Validators.required, Validators.maxLength(500)]]
    });

    try {
      await this.mapsLoader.load();
      this.mapReady = true;

      setTimeout(() => {
        const mapOptions: google.maps.MapOptions = {
          center: { lat: -33.4372, lng: -70.6506 },
          zoom: 12,
          disableDefaultUI: false,
        };
        if (this.mapElementRef) {
          this.map = new google.maps.Map(this.mapElementRef.nativeElement, mapOptions);
        }
      }, 0);
    } catch (err) {
      console.error('Error al cargar Google Maps:', err);
    }
  }

  async onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.formSubmitted = true;
    await firstValueFrom(this._sendEmail.sendEmail(this.form.value));

    setTimeout(() => {
      this.form.reset();
      this.formSubmitted = false;
    }, 1000);
  }

    resetForm() {
    this.form.reset({ name: '', email: '', message: '' });
    this.formSubmitted = false;
  }
  
  get name() { return this.form.get('name'); }
  get email() { return this.form.get('email'); }
  get message() { return this.form.get('message'); }

}
